import React from "react";
import "./Laurel.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Laurel10images from "../../../Media/BSD/Navapark/Laurel10";
import Laurel12images from "../../../Media/BSD/Navapark/Laurel12";

const imageMap = {
  Laurel10images,
  Laurel12images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Wynyard" className="Wynyard">
      <h1>Welcome to Laurel</h1>
      <h2>Cicilan Start 65 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
